module.exports = __webpack_public_path__ + "static/media/clock.3c12c7d2.png";